module.exports = __webpack_public_path__ + "static/media/not_found.d45545fb.svg";